import React from "react";
import { CheckCircle2 } from "lucide-react";

const points = [
"Engineering-first specification support for architects and contractors",
"Systems matched to actual thermal and seismic movement requirements",
"Materials sourced and tested to international performance standards",
"Dedicated project support from RFQ to installation guidance"];


export default function WhySeisfra() {
  return (
    <section className="bg-white py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div>
          <p className="font-tech font-semibold uppercase tracking-[0.2em] text-[#E4001C] text-sm mb-3">Why Seisfra</p>
          <h2 className="font-heading font-extrabold uppercase text-4xl md:text-5xl tracking-wide mb-6 text-[#171717]">
            Built for the Gap That Matters
          </h2>
          <p className="text-[#171717]/70 leading-relaxed mb-8">Expansion joints are the most stressed  and most overlooked  components of any structure. Seisfra treats them as critical engineering, not afterthoughts. Our systems are specified, supplied, and supported with the precision your project deserves.



          </p>
          <ul className="space-y-4">
            {points.map((p) =>
            <li key={p} className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-[#E4001C] mt-0.5 shrink-0" />
                <span className="text-[#171717]/80 text-sm leading-relaxed">{p}</span>
              </li>
            )}
          </ul>
        </div>
        <div className="relative">
          <div className="absolute -top-4 -left-4 w-full h-full border-2 border-[#E4001C]" />
          <img
            src="https://base44.app/api/apps/6a45c3b894a45b7fc0b9be49/files/mp/public/6a45c3b894a45b7fc0b9be49/45b9d129d_whyseisfra.webp"
            alt="High-tech steel fabrication facility"
            loading="lazy"
            decoding="async"
            className="relative w-full aspect-[16/10] object-cover" />
          
        </div>
      </div>
    </section>);

}